const routes = {
  '/app/instant/:id': {
    fetch: () =>
      import(
        /* webpackChunkName: 'instant-make-a-zap' */ 'app/instant-zap/asyncRoute'
      ).then(module => module.default),
  },
};

export default routes;
